import { useState } from 'react';
import styles from './on-street-parking-information.module.sass';
import { CheckCircleFillIcon, ChevronDownIcon } from 'icons';
import classnames from 'classnames/bind';
import analytics from 'service/analytics';
const cx = classnames.bind(styles);

export const OnStreetParkingInformation = ({ enableOnStreetParkingAutoPay }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!enableOnStreetParkingAutoPay) return null;

  return (
    <div
      style={{ marginBottom: '16px' }}
      className={cx('container')}
      onClick={() => {
        analytics.track('帳號資訊頁-路停自動繳_click', {
          動作: isOpen ? '收合' : '展開',
        });
        setIsOpen(prev => !prev);
      }}
    >
      <div className={cx('container-preview')}>
        <div className={cx('container-left-part')}>
          <div className={cx('container-left-part-label')}>路邊停車自動繳費</div>
          <div className={cx('container-left-part-value')}>
            <CheckCircleFillIcon color="#00D7B2" width={20} height={20} style={{ marginRight: '2px' }} />
            已開啟
          </div>
        </div>
        <div className={cx('container-right-part')}>
          適用縣市
          <ChevronDownIcon className={cx('chevron-icon', { reversed: isOpen })} width={20} height={20} />
        </div>
      </div>
      {isOpen ? (
        <div className={cx('container-hidden-section')}>
          基隆市、台北市、新北市、桃園市、新竹縣、新竹市、苗栗市、台中市、彰化縣、台南市、高雄市、宜蘭縣、花蓮縣、台東縣、澎湖縣
        </div>
      ) : null}
    </div>
  );
};
